<template>
  <common-dialog ref="dialog" width="95%" title="编辑快递模板" id-key="id" :data="data" :form-rules="rules"
    :save-func="saveDataFunc" @edit-opened="onEditOpened" @closed="onClosed" @close-saved="$emit('close-saved')"
    close-on-saved>
    <template slot="form">
      <div class="box">
        <div class="left">
          <div class="temp-box" :style="[{'width':tempWidth},{'height': tempHeight}]">
            <el-image
              src="https://cdn4.codesign.qq.com/prototypes/2024/03/22/Yyg5Z24px8Qo03Z2lKv22/fg0vjemgcicsecmr/4a220f1a2fe805a886c41fbfc6b73de6.png"></el-image>
            <custom-area ref="customArea" :style="[{'width':customWidth},{'height':customHeight},{'left':customLeft}]"
              @remove-field="onRemoveField"></custom-area>
          </div>
          <div style="text-align: center;padding-top: 8px;color: #797979;">可选中信息进行拖拽或调整文字大小</div>
        </div>
        <div class="right">
          <div class="title-box">模板信息</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="模板名称" prop="模板名称">
                <el-input v-model="data.模板名称" placeholder="请输入模板名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板样式" prop="标准模板" label-width="110px">
                <el-select v-model="data.标准模板" placeholder="请选择" @change="onTempChange">
                  <el-option v-for="(i,k) in templateList" :key="k" :label="i.name" :value="i.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="发货地址" prop="默认发货地址">
                <el-select v-model="data.默认发货地址" placeholder="请选择">
                  <el-option v-for="(i,k) in 发货地址列表" :key="k" :label="i.name" :value="i.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="网点发货地址" prop="网点发货地址" label-width="110px">
                <el-select v-model="data.网点发货地址" placeholder="请选择">
                  <el-option v-for="(i,k) in 发货地址列表" :key="k" :label="i.name" :value="i.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title-box">自定义展示信息</div>
          <div class="item-box">
            <div class="item-title">推荐组合</div>
            <div class="item-content">
              <el-radio-group v-model="data.推荐组合" @change="onRadioChange">
                <el-radio :label="1">规格+数量水印+卖家备注</el-radio>
                <el-radio :label="2">规格、数量+卖家备注</el-radio>
                <el-radio :label="3">商品名称+规格+数量+多包</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="item-box">
            <div class="item-title">全部字段</div>
            <div class="item-content">
              <div class="check-box" v-for="(i,k) in fieldList" :key="k">
                <el-checkbox v-model="i.checked" @change="onCheckChange(i)">{{ i.text }}</el-checkbox>
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="item-title"></div>
            <div class="item-content">
              <div class="custom-field" v-for="(i,k) in customFields" :key="k">
                <el-checkbox v-model="i.checked" @change="onCheckChange(i)">{{ i.text }}</el-checkbox>
                <el-input v-model="i.content" placeholder="请输入"></el-input>
              </div>
            </div>
          </div>
          <div class="title-box">自定义模板调整</div>
          <div class="item-box">
            <div class="item-title">字段调整</div>
            <div class="item-content">
              <div class="img-btn" @click="onFontChange('up')">
                <el-image :src="require('@/assets/fontup.png')"></el-image>
              </div>
              <div class="img-btn" @click="onFontChange('down')">
                <el-image :src="require('@/assets/fontdown.png')"></el-image>
              </div>
              <div class="img-btn" @click="onFieldDelete">
                <el-image :src="require('@/assets/delete.png')"></el-image>
              </div>
            </div>
          </div>
          <!-- <div class="item-box">
            <div class="item-title">区域调整</div>
            <div class="item-content">
              <el-input-number v-model="customHeight" :precision="1"></el-input-number>
              <div style="margin-left: 10px;font-size: 12px;color: #797979;">调整自定义区域高度，单位毫米（mm）。</div>
            </div>
          </div> -->
        </div>
      </div>
      <div id="xml_data" style="display: none;" v-html="xmlDataStr"></div>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import axios from 'axios'
import xmlRequest from '@/utils/xmlRequest';
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';
import customArea from "./customArea";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    customArea
  },
  data() {
    return {
      // api: require('@/api/ent/dp').default,
      fileApi: require('@/api/file/files').default,
      pddLogisticsApi: require('@/api/pdd/logistics').default,
      fieldList: require('@/assets/print_fields.json'),
      data: {
        id: 0,
        电子面单账号店铺: '',
        快递公司: null,
        wpCode: "",
        快递公司文本: "",
        标准模板: 96,
        标准模板名称: "",
        标准模板类型: "（二联单）",
        模板名称: "",
        网点发货地址: null,
        增值服务: false,
        默认发货地址: null,
        推荐组合: null,
      },
      xmlDataStr: null,
      tempZoom: 1,
      tempWidth: "",
      tempHeight: "",
      customWidth: "",
      customHeight: "",
      customLeft: "",
      templateList: [],
      发货地址列表: [{
        id: 1,
        name: "浙江省金华市义乌市樊村46号楼5单元1楼",
        number: 9
      }, {
        id: 2,
        name: "上海市上海市闽行区七宝镇中春路7335号",
        number: 300
      }],
      customFields: [{
        "field": "自定义文字1",
        "text": "自定义文字1",
        "content": "",
        "checked": false
      }, {
        "field": "自定义文字2",
        "text": "自定义文字2",
        "content": "",
        "checked": false
      }, {
        "field": "自定义文字3",
        "text": "自定义文字3",
        "content": "",
        "checked": false
      }],
      rules: {
        电子面单账号店铺: [{ required: true, message: '请选择电子面单账号店铺' }],
        快递公司: [{ required: true, message: '请选择快递公司' }],
        模板名称: [{ required: true, message: '模板名称不能为空' }],
        网点发货地址: [{ required: true, message: '请选择网点发货地址' }],
        默认发货地址: [{ required: true, message: '请选择默认发货地址' }],
      },
    };
  },
  mounted() {
    // console.log("字段列表", this.fieldList)
  },
  methods: {
    onEditOpened() {
      this.xmlDataStr = "";
      this.$refs.customArea.init();
      this.data.wpCode = "YZXB";
      this.getTemplates(this.data.wpCode);
      var data_str = localStorage.getItem("custom");
      console.log("data", JSON.parse(data_str));
      if (data_str) {
        var data = JSON.parse(data_str);
        this.$refs.customArea.setCustomData(data);
        data.domData.forEach(x => {
          var field = this.fieldList.find(w => w.field == x.domId);
          field.checked = true;
        })
      }
    },
    getTemplates(code) {
      this.templateList = [];
      this.pddLogisticsApi.standardtemplates(code).then(res => {
        if (!res.errorCode) {
          this.templateList = res.data.map(x => {
            return { id: x.id, name: x.standardTemplateName, url: x.standardTemplateUrl }
          });
          this.onTempChange(this.data.标准模板)
        }
      }).catch((err) => {
        this.$message.error("服务器未响应");
      })
    },
    onTempChange(data) {
      var temp = this.templateList.find(x => x.id == data);
      this.data.标准模板名称 = temp.name;
      let loading = this.$loading({
        lock: true,
        text: "正在获取模板信息...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      var newUrl = temp.url;
      if (newUrl.indexOf("https://file-link.pinduoduo.com") != -1) {
        newUrl = newUrl.replace("https://file-link.pinduoduo.com", "/pddxml")
      }
      xmlRequest({ url: newUrl, method: 'get' }).then((response) => {
        loading.close();
        this.xmlDataStr = response.data;
        this.$nextTick(() => {
          var xml_data = document.getElementById("xml_data");
          console.log("xml_data", [xml_data]);
          var page = xml_data.firstElementChild;
          if (page) {
            this.tempWidth = (page.attributes.width.value / 2) + "px";
            this.tempHeight = (page.attributes.height.value / 2) + "px";
            console.log("宽1", this.tempWidth, "高1", this.tempHeight);
            var user = page.querySelector('[name="user"]');
            if (user) {
              // console.log("user", [user])
              this.customWidth = (user.attributes.width.value / 2) + "px";
              this.customHeight = (user.attributes.height.value / 2) + "px";
              if (user.attributes.left) {
                this.customLeft = (user.attributes.left.value / 2) + "px";
              }
              console.log("宽2", this.customWidth, "高2", this.customHeight, "左边距", this.customLeft);
            }
          }
          this.fieldList.forEach(x => x.checked = false);
          this.$refs.customArea.clear(true);
        })
      }).catch((error) => {
        loading.close();
        console.log("xml_error", error)
      })
    },
    onRadioChange(e) {
      console.log("onRadioChange", e)
      var items = {
        item1: ["规格", "商品数量水印", "卖家备注"],
        item2: ["规格+数量", "卖家备注"],
        item3: ["商品名称", "规格", "数量", "多包"],
      }
      //重置
      this.fieldList.forEach(x => x.checked = false);
      this.$refs.customArea.clear(true);

      items["item" + e].forEach(x => {
        var data = this.fieldList.find(w => w.field == x);
        data.checked = true;
        this.$refs.customArea.onCheckChange(data);
      })
    },
    onCheckChange(data) {
      this.$refs.customArea.onCheckChange(data);
    },
    onFontChange(type) {
      this.$refs.customArea.onFontChange(type);
    },
    onFieldDelete() {
      this.$refs.customArea.onFieldDelete();
    },
    onRemoveField(id) {
      var field = this.fieldList.find(x => x.field == id);
      if (field) {
        field.checked = false;
      } else {
        var custom_field = this.customFields.find(x => x.field == id);
        custom_field.checked = false;
      }
    },
    getXmlData() {
      var data = this.$refs.customArea.getCustomData();
      localStorage.setItem("custom", JSON.stringify(data));

      var xml_script = "";
      var xml_value = "";
      data.domData.forEach(x => {
        xml_script += `<%var ${x.domId} = data.sender ? (data.sender.${x.domId} || '') : '' %>`;
        xml_value += `<text height="${x.height * 2}" top="${x.y * 2}" width="${x.width * 2}" left="${x.x * 2}" value="<%=${x.domId}%>" fontSize="${x.dataset.fontSize * 2}" />`
      })
      var xml_text = xml_script + xml_value;
      // console.log("xml_text", xml_text)

      var zdy_index = this.xmlDataStr.indexOf('自定义');
      console.log("自定义", zdy_index)

      var xml_data = document.getElementById("xml_data");
      var user = xml_data.querySelector('[name="user"]');
      if (user) {
        var w = user.attributes.width.value;
        var h = user.attributes.height.value;

        var start_str = '<layout name="user" height="' + h + '" width="' + w + '" >';
        var start_index = this.xmlDataStr.indexOf(start_str, zdy_index);
        var end_index = this.xmlDataStr.indexOf('</layout>', zdy_index);
        console.log("开始", start_index, "结束", end_index);

        var first = this.xmlDataStr.slice(0, start_index + start_str.length);
        var end = this.xmlDataStr.slice(end_index);

        this.xmlDataStr = first + xml_text + end;
        return new Blob([this.xmlDataStr], { type: 'application/xml' });
      } else {
        return null;
      }
    },
    onUploadXml(fileData) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("Type", 10001); //拼多多 自定义打印模板 XML
        formData.append('File', fileData, this.data.标准模板名称 + ".xml");
        this.fileApi.uploadXml(formData).then(res => {
          console.log("res", res)
          resolve(res);
        }).catch(err => {
          console.log("err", err);
          reject(err);
        })
      })
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        var fileData = this.getXmlData();
        if (fileData) {
          this.onUploadXml(fileData).then(res => {
            if (res.fileId) {
              var temp = {
                wpCode: this.data.wpCode,
                customTemplateName: res.fileName,
                customTemplateFileNumber: res.fileId
              }
              this.pddLogisticsApi.postCustomtemplates(temp).then(res => {
                if (res) {
                  resolve({ Code: 1, Msg: res.errorMessage })
                } else {
                  resolve({ Code: 0, Msg: null })
                }
              }).catch(err => {
                this.$message.error("服务器未响应");
                reject({ Code: 1, Msg: "服务器未响应" })
              })
            } else {
              resolve({ Code: 1, Msg: "保存模板失败" })
            }
          }).catch(err => {
            this.$message.error("服务器未响应");
            reject({ Code: 1, Msg: "服务器未响应" })
          })
        } else {
          resolve({ Code: 1, Msg: "保存模板失败" })
        }
      })
    },
    onClosed() {
      this.fieldList.forEach(x => x.checked = false);
      this.$refs.customArea.clear();
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;

  .left {
    width: 450px;
    height: 800px;
    padding: 10px;
    border: 1px solid #E4E7ED;

    .temp-box {
      margin: auto;
      position: relative;

      .el-image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .right {
    margin-left: 10px;
    width: calc(100% - 460px);
    border: 1px solid #E4E7ED;
    padding: 0 10px;

    .title-box {
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
    }

    .item-box {
      display: flex;
      line-height: 40px;

      .item-title {
        width: 80px;
      }

      .item-content {
        width: calc(100% - 80px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .check-box {
          width: 25%;
        }

        .custom-field {
          width: 100%;
          display: flex;

          .el-input {
            margin-left: 10px;
            max-width: 600px;
          }
        }

        .img-btn {
          width: 36px;
          height: 36px;
          border: 1px solid #b4b4b4;
          margin-right: 10px;
          cursor: pointer;
          padding: 5px;
        }
      }
    }
  }
}
</style>